/**
 * Projects Module Routes
 *
 * Route definitions for the Projects module.
 * All routes are relative to the module path (/projects).
 */

import type { RouteRecordRaw } from 'vue-router'
import ModuleLayout from '@/layouts/ModuleLayout.vue'

const routes: RouteRecordRaw[] = [
    {
        path: '/projects',
        component: ModuleLayout,
        meta: {
            moduleKey: 'projects',
        },
        children: [
            {
                path: '',
                name: 'projects-list',
                component: () => import('./views/ProjectList.vue'),
                meta: {
                    title: 'All Projects',
                },
            },
            {
                path: 'create',
                name: 'projects-create',
                component: () => import('./views/ProjectCreate.vue'),
                meta: {
                    title: 'New Project',
                    moduleKey: 'projects',
                },
            },
            {
                path: ':id',
                name: 'projects-detail',
                component: () => import('./views/ProjectDetail.vue'),
                meta: {
                    title: 'Project Details',
                },
            },
        ],
    },
]

export default routes
